<template>
  <v-app>
    <div class="B-groupbar TF">
      <div
        ref="menuMain"
        id="menuMain"
        class="manubar"
        v-if="!publicpath.includes(this.$router.history.current.name)"
      >
        <MenuBar v-if="ready" />
      </div>
      <div id="contentMain" class="briefscan">
        <div class="toolbar" v-if="!publicpath.includes(this.$router.history.current.name)">
          <Toolbar v-if="ready" />
        </div>

        <router-view v-if="ready" />
      </div>
    </div>
  </v-app>
</template>

<script>
import feathersClientUOA from "./plugins/feathers-client-uoa";

import Toolbar from "../src/components/Toolbar.vue";
import MenuBar from "../src/components/MenuBar.vue";
import Vue from "vue";
export default {
  name: "App",
  components: {
    Toolbar,
    MenuBar,
  },
  data: () => ({
    ready: false,
    publicpath: [
      "BriefScan",
      "MubadalaForCustomer",
      "MubadalaForCustomerDetail",
      "MubadalaForCustomerEForm1",
      "MubadalaForCustomerEForm2",
      "MubadalaForCustomerEForm3",
      "MubadalaForCustomerEFormSignature",
      "MubadalaForCustomerEFormThankYou",
    ],
    test: [],
  }),

  async beforeCreate() {
    document.onreadystatechange = async () => {
      if (document.readyState == "complete") {
        if (this.publicpath.includes(this.$router.history.current.name)) {
          var anonymousUser = {
            u_id: 50,
            u_firstname: "anonymous",
            u_lastname: "",
            u_staffcode: null,
            u_imageurl: "/img/user.png",
            u_active: null,
            u_username: "",
            r_id: 16,
            r_name: "",
            c_id: 4,
            c_name: "",
            o_id: 4,
            o_name: "",
            o_image:
              "data:image/png;base64,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",
            u_email: null,
            u_password:
              "",
            u_tital: null,
            u_address: null,
            u_telephone: null,
            u_national_id: null,
            u_bloodgroup: null,
            u_idcard_no: null,
            u_gender: null,
            u_birthdate: null,
            u_locker_no: null,
            u_estimatedweight: null,
            u_estimatedtall: null,
            u_emergency_contact: null,
            u_emergency_relation: null,
            u_emergency_telphone: null,
            u_crewtype: null,
            u_homephone: null,
            u_department: null,
            u_jobposition: null,
            u_safety_training: null,
            u_medical_checkup: null,
            u_remark: null,
            u_file: null,
            u_piority: null,
            cb: null,
            cd: null,
            mb: null,
            md: null,
            retire: "0",
            FullName: "anonymous",
            MedicalCheckupDayLeft: null,
            SafetyTrainingDayLeft: null,
            ShortName: "anonymous",
            CodeName: "anonymous",
          };
          await window.localStorage.setItem(
            "user",
            JSON.stringify(anonymousUser)
          );
          this.ready = true;
        } else {
          try {
            await feathersClientUOA.reAuthenticate();
            const accessToken =
              await feathersClientUOA.authentication.getAccessToken();
            var response = await feathersClientUOA.authenticate({
              strategy: "jwt",
              accessToken: accessToken,
            });

            var res = await feathersClientUOA
              .service("viewaccount")
              .find({ query: { retire: 0, u_id: response.account.u_id } });

            await window.localStorage.setItem(
              "user",
              JSON.stringify(res.data[0])
            );
            this.ready = true;
          } catch (error) {
            window.location.replace("/login.html");
            console.log(error);
          }
        }
      }
    };
  },
};
</script>
<style>
@import "../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../node_modules/@syncfusion/ej2-buttons/styles/material.css";
@import "../node_modules/@syncfusion/ej2-calendars/styles/material.css";
@import "../node_modules/@syncfusion/ej2-dropdowns/styles/material.css";
@import "../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../node_modules/@syncfusion/ej2-navigations/styles/material.css";
@import "../node_modules/@syncfusion/ej2-popups/styles/material.css";
@import "../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
</style>
